module.exports = __webpack_public_path__ + "img/MAC1680_2480-3508.f3f9a656.jpg";